import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { KvCalendarComponent } from 'app/modules/UIKit/components/kv-calendar/kv-calendar.component';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { EventsService } from 'app/services/audit/events.service';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  breadcrumbs: Array<BreadCrumbModel> = [];
  dateRangeForm: FormGroup;
  statusList: Array<{ label: string, value: string }>;
  paginationType = Campaign3KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  noFilter = KontableComponent.NoFilter;
  customFilter = KontableComponent.CustomFilter;
  invalidSubmit = false;
  pageSubject = "Events";
  translations: any;
  showPopupInfoInsideTable = false;
  selectedEventContent = null;
  @ViewChild('dateStartField') dateStartField: KvCalendarComponent;
  @ViewChild('dateEndField') dateEndField: KvCalendarComponent;

  constructor(
    public eventsService: EventsService,
    private translate: TranslateService,
    private fb: FormBuilder,
    public srvCalendar: CalendarTranslateService,


  ) {
    this.statusList = [
      { value: "0", label: this.translate.instant("audit.eventElStarted") },
      { value: "1", label: this.translate.instant("audit.eventElOk") },
      { value: "9", label: this.translate.instant("audit.eventElKo") },
      { value: null, label: this.translate.instant('common.all') }];
  }

  ngOnInit() {
    this.initBreadCrumbs();
    this.initForm();
  }

  initBreadCrumbs() {
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = this.translate.instant('audit.manageEvents');
    this.breadcrumbs.push(bc1);
    let bc2 = new BreadCrumbModel();
    bc2.code = "bc2";
    bc2.description = this.translate.instant('audit.listEvents');
    this.breadcrumbs.push(bc2);
  }


  initForm() {
    this.dateRangeForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required]
    });
  }


  clearDateFilters() {
    this.dateRangeForm.reset();
    this.dateStartField.clearInputField();
    this.dateEndField.clearInputField();
  }
  //Aprire popup con kjson da visualizzare
  onOpenInfoAction(row: any) {

    if (row === undefined) {
      console.error("row is undefined!");
      return;
    }
    if (!this.showPopupInfoInsideTable) {
      // Create a deep copy to avoid modifying the original row in the table
      const processedRow = JSON.parse(JSON.stringify(row));

      if (typeof processedRow.newRow === 'string') {
        try {
          processedRow.newRow = JSON.parse(processedRow.newRow);
        } catch (e) {
          console.warn("Could not parse newRow as JSON", e);
        }
      }

      if (typeof processedRow.oldRow === 'string') {
        try {
          processedRow.oldRow = JSON.parse(processedRow.oldRow);
        } catch (e) {
          console.warn("Could not parse oldRow as JSON", e);
        }
      }

      this.selectedEventContent = processedRow;
      this.showPopupInfoInsideTable = true;
    }
  }
  onClosePopupInfo() {

    this.showPopupInfoInsideTable = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/audit/events/events.component.ts